import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useState, useEffect } from "react";
import AreaWisePOB from "./AreaWisePOB";
import CalendarGridPOB from "../calender-grid/CalendarGridPOB";
import { RegionsType } from "../../../../../domain/models/daily-pob-report/dailypobreport";
import { DownloadJSON } from "../../../../../domain/models/daily-visit-report/downloadJSON";

type Props = {
  data: RegionsType;
  month: number;
  year: number;
  type: string;
  departmentId: string | null;
  downloadJSON: DownloadJSON[];
  customerTypeId: string | null;
};

const RegionWisePOB: React.FC<Props> = ({
  data,
  month,
  year,
  type,
  departmentId,
  downloadJSON,
  customerTypeId,
}) => {
  const columns = [
    { field: "User" },
    { field: "Territory" },
    { field: "Daily POB Target" },
    { field: "% to POB Target" },
    { field: "Status" },
  ];
  
  const daysInMonth = new Date(year, month, 0).getDate();
  const [totalAll, setTotalAll] = useState<number[]>(
    new Array(daysInMonth).fill(0)
  );
  const [totalRow, setTotalRow] = useState<JSX.Element[]>([]);
  const [total, setTotal] = useState<number>(0);

  useEffect(() => {
    setTotalAll(new Array(daysInMonth).fill(0));
    const arr = new Array(daysInMonth).fill(0);
    data.areas.forEach((area, key) => {
      area.headquarters.forEach((hq, key) => {
        hq.monthly_data.forEach((month, key) => {
          if (type === "rupee" && month.rupees !== undefined) {
            arr[month.day - 1] += month.rupees;
          } else if (
            type === "order_count" &&
            month.order_count !== undefined
          ) {
            arr[month.day - 1] += month.order_count;
          } else if (type === "quantity" && month.quantity !== undefined) {
            arr[month.day - 1] += month.quantity;
          }
        });
      });
    });
    setTotalAll(arr);
  }, [type]);

  const regionJSON: any = {};
  regionJSON.role = "RBM";
  regionJSON.user = data.rbm_name;
  regionJSON.territory = data.region_name;
  useEffect(() => {
    const totalSum = totalAll.reduce(
      (acc, currentValue) => acc + currentValue,
      0
    );

    setTotal(totalSum);
    regionJSON.total =
      type === "rupee" ? (totalSum / 100000).toFixed(1) : totalSum;
  
    
    const getDayOfWeek = (day: number) => {
      return new Date(year, month - 1, day).getDay();
    };
    const totalRowCells = totalAll.map((total, index) => {
      const isSunday = getDayOfWeek(index + 1) === 0;
      regionJSON[index + 1] = isSunday
        ? "H"
        : type === "rupee"
        ? (total / 1000).toFixed(1)
        : total;
      return (
        <TableCell
          key={index}
          sx={{
            border: "2px solid white",
            padding: 0,
            fontSize: 12,
            width: 30,
            backgroundColor: "#cfeafc",
            textAlign: "center",
          }}
        >
          {isSunday
            ? "H"
            : type === "rupee"
            ? (total / 1000).toFixed(1)
            : total}
        </TableCell>
      );
    });
    setTotalRow(totalRowCells);

    const existingIndex = downloadJSON.findIndex(
      (item) => item.user === regionJSON.user
    );
    if (existingIndex !== -1) {
      downloadJSON[existingIndex] = regionJSON;
    } else {
      downloadJSON.push(regionJSON);
    }
  }, [totalAll, month, year, type]);

  

  return (
    <>
      <TableContainer
        sx={{
          boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
          borderRadius: "10px",
          border: "2px solid white",
          maxWidth: 1500,
        }}
      >
        <Table sx={{ minWidth: "100%", tableLayout: "auto" }}>
          <TableHead>
            <TableRow>
              <CalendarGridPOB columns={columns} year={year} month={month} />
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell
                padding="none"
                sx={{
                  border: "2px solid white",
                  width: 80,
                  padding: 0,
                  fontSize: 12,
                }}
                colSpan={6}
              ></TableCell>
              <TableCell
                sx={{
                  border: "2px solid white",
                  fontSize: 12,
                  padding: 0,
                  textAlign: "center",
                  width: 80,
                }}
              >
                {type === "rupee" ? (total / 100000).toFixed(1) : total}
              </TableCell>
              {totalRow}
            </TableRow>
            {data.areas.map((area) => (
              <AreaWisePOB
                data={area}
                month={month}
                year={year}
                type={type}
                departmentId={departmentId}
                downloadJSON={downloadJSON}
                customerTypeId={customerTypeId}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default RegionWisePOB;
